<script setup lang="ts">
import AlertModal from './components/modals/AlertModal.vue'
import { ar, en, hr } from '@nuxt/ui/locale'

const { locale, locales, t } = useI18n({
  useScope: 'global',
})

// Nuxt UI has no 'sr' locale — use 'hr' (Croatian) as the closest match
const uiLocaleMap: Record<string, typeof en> = { en, sr: hr, ar }
const nuxtUiLocale = computed(() => uiLocaleMap[locale.value] ?? en)
const { setupZodI18n } = useZodI18n()
const colorMode = useColorMode()

const color = computed(() => (colorMode.value === 'dark' ? '#1b1718' : 'white'))
const lang = computed(() => locale.value || 'sr')

useHead({
  meta: [
    { charset: 'utf-8' },
    { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    { key: 'theme-color', name: 'theme-color', content: color },
  ],
  link: [{ rel: 'icon', href: '/favicon.ico' }],

  htmlAttrs: {
    lang,
  },
})

watch(
  locale,
  (val) => {
    // Update lang attribute of html tag
    if (typeof document !== 'undefined') {
      document.documentElement.setAttribute('lang', val as string)
    }
    setupZodI18n()
  },
  { immediate: true }
)

const title = t('meta.title')
const description = t('meta.description')

useSeoMeta({
  title,
  description,
  ogTitle: title,
  ogDescription: description,
  ogImage:
    'https://assets.hub.nuxt.com/eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJodHRwczovL2Rhc2hib2FyZC10ZW1wbGF0ZS5udXh0LmRldiIsImlhdCI6MTczOTQ2MzU2N30._VElt4uvLjvAMdnTLytCInOajMElzWDKbmvOaMZhZUI.jpg?theme=light',
  twitterImage:
    'https://assets.hub.nuxt.com/eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJodHRwczovL2Rhc2hib2FyZC10ZW1wbGF0ZS5udXh0LmRldiIsImlhdCI6MTczOTQ2MzU2N30._VElt4uvLjvAMdnTLytCInOajMElzWDKbmvOaMZhZUI.jpg?theme=light',
  twitterCard: 'summary_large_image',
})

onMounted(() => {
  setupZodI18n()
})
</script>

<template>
  <UApp :locale="nuxtUiLocale">
    <AlertModal />
    <NuxtLoadingIndicator />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <div id="my-alert-container"></div>
  </UApp>
</template>
